// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  resultId: __t.u64().primaryKey().name("result_id"),
  correlationId: __t.string().name("correlation_id"),
  reducerName: __t.string().name("reducer_name"),
  status: __t.string(),
  message: __t.string(),
  details: __t.string(),
  completedAt: __t.timestamp().name("completed_at"),
});
